import script from "./HAppCardUsageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HAppCardUsageItem.vue?vue&type=script&setup=true&lang=js"

import "./HAppCardUsageItem.vue?vue&type=style&index=0&id=2c906c6d&lang=scss&scoped=true"
script.__scopeId = "data-v-2c906c6d"

export default script